module.exports = require('./src/normalizeWheel.js');



// WEBPACK FOOTER //
// ./node_modules/_normalize-wheel@1.0.1@normalize-wheel/index.js